import {ReactElement} from "react";
import { PText} from "@porsche-design-system/components-react";
import { Flex } from "@react-css/flex";

interface ControlProps {
    assignedQuotes: number;
    overAllQuote: number;
}

export function QuotaInformation(props: ControlProps): ReactElement {
    return (
        <Flex row={true}  justifyContent={"flex-start"}>
            <PText weight={"bold"} className={"quotesText"} autoFocus={false} inert>
                Available quotas: {props.overAllQuote - props.assignedQuotes} of {props.overAllQuote}
            </PText>
            {props.overAllQuote - props.assignedQuotes < 0 && (
                <PText weight={"bold"} className={"quotesText warning"} color={"notification-error"} autoFocus={false}
                       inert>
                    Reserved/booked limitation numbers exceed quotas
                </PText>
            )}
        </Flex>
    );
}